import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-507e5462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "copy-section__text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M9.131 17.023H3.145a2.51 2.51 0 0 1-2.507-2.507V6.023a2.51 2.51 0 0 1 2.507-2.507h5.986a2.51 2.51 0 0 1 2.507 2.507v8.493a2.51 2.51 0 0 1-2.507 2.507zM3.145 4.769c-.691 0-1.253.562-1.253 1.254v8.493c0 .691.562 1.253 1.253 1.253h5.986c.691 0 1.253-.562 1.253-1.253V6.023c0-.692-.562-1.254-1.253-1.254H3.145zm11 8.179V3.484A2.51 2.51 0 0 0 11.638.977H4.681a.627.627 0 0 0 0 1.254h6.957c.691 0 1.254.562 1.254 1.253v9.464a.626.626 0 1 0 1.253 0z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.copied)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copied = undefined)),
          variant: "primary",
          title: "با موفقیت کپی شد",
          duration: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
      class: "copy-section"
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.text), 1),
      _hoisted_2
    ])
  ], 64))
}